import Gallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import './ImageSlider.css';
import Link from 'next/link';
import getOption from '@/src/utils/getOption';
import { useTranslations } from 'next-intl';
import { FaDownload } from 'react-icons/fa6';

export default function ImageSlider({
  images,
  id,
}: {
  images: any;
  id?: number;
}) {
  const t = useTranslations('page.item');
  return (
    <div
      className='mx-auto w-full min-w-[200px]'
      style={{ maxWidth: 'calc(-400px + 123vh)' }}
    >
      <style>
        .image-gallery.fullscreen-modal {'{z-index: 60}'}
        .image-gallery + .download-all {'{display: none}'}
        .image-gallery.fullscreen-modal + .download-all{' '}
        {'{display: flex; z-index: 61}'}
      </style>
      <Gallery
        items={images.map((image: any) => ({
          original: image.url_medium || image.url,
          thumbnail: image.url_thumbnail || image.url_medium || image.url,
          fullscreen: image.url,
        }))}
        useBrowserFullscreen={false}
        showPlayButton={false}
        showIndex={true}
      />
      {id && (
        <Link
          href={`${getOption('API_URL')}ad/${id}/images`}
          className='download-all fixed right-20 top-0 flex items-center gap-2 border border-brand bg-brand px-4 py-1 text-sm font-semibold uppercase text-dark transition-all hover:bg-transparent hover:text-white'
          target='_blank'
        >
          <FaDownload /> {t('downloadAll')}
        </Link>
      )}
    </div>
  );
}
